import {
  DELETE_PROFILE_CARDS_CATALOG,
  DELETE_PROFILE_CARDS_CATALOG_SUCCESS,
  DELETE_PROFILE_CARDS_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const deleteProfileCardCatalogRed = (state: any = false, actions: any) => {
  switch (actions.type) {
    case DELETE_PROFILE_CARDS_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case DELETE_PROFILE_CARDS_CATALOG_SUCCESS:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case DELETE_PROFILE_CARDS_CATALOG_ERROR:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
